import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import PostCard from "@/pages/blog/components/PostCard";
import { getRelatedPosts, type BlogPost } from "@/pages/blog/blogData";

export default function RelatedPosts({ post }: { post: BlogPost }) {
  const related = getRelatedPosts(post, 3);
  if (related.length === 0) return null;

  return (
    <section className="border-t border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          align="left"
          badge="Continue aprendendo"
          badgeIcon="ri-book-open-line"
          title="Continue aprendendo"
          description="Outros conteúdos da NXHOST que combinam com o que você acabou de ler."
        />
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {related.map((item, index) => (
            <Reveal key={item.slug} delay={index * 40}>
              <PostCard post={item} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}